import { useEffect, useState } from 'react';
function useIsClient() {
    const [isClient, setClient] = useState(false);
    useEffect(() => {
        setClient(true);
    }, []);
    return isClient;
}
export default useIsClient;
